// Signers are reviewers here but get their own section in the UI, so name the role.
export const pastDueDateMessage = (isSigner?: boolean | null) =>
  `${isSigner ? "Signer" : "Reviewer"} due date cannot be in the past (based on UTC)`;

export const REVIEWER_DUE_DATE_MESSAGES = {
  PAST_DUE_DATE: pastDueDateMessage(false),
  AFTER_SUBMISSION: "Due date must be before submission due date",
  AFTER_NEXT_REVIEWER:
    "Due date must be before the next reviewer's due date if priority order is selected",
};

// Drift-into-invalid messages — suppressed by consumers when the persisted reviewer is unchanged.
export const GRANDFATHERABLE_REVIEWER_DUE_DATE_MESSAGES: ReadonlySet<string> = new Set([
  pastDueDateMessage(false),
  pastDueDateMessage(true),
  REVIEWER_DUE_DATE_MESSAGES.AFTER_SUBMISSION,
  REVIEWER_DUE_DATE_MESSAGES.AFTER_NEXT_REVIEWER,
]);
